import { TransitionGroup } from 'react-transition-group';
import styled from 'styled-components';

export const Transition = styled(TransitionGroup)`
  height: 100%;
`;
